( function () {
	'use strict';

	function GroupIndicator ( $q, dataservice, logger, collectionService, indicatorService, apiService, $scope ) {
		var self = this;

		function trimTemplateName () {
			var template = $scope.$parent.$parent.vm.templateModel.template;

			template.name = template.name.trim();
		}

		function getIndicatorsHandler () {
			return indicatorService.getIndicators();
		}

		function addIndicatorHandler ( key, index ) {
			var indicatorModel = indicatorService.getData( key );

			indicatorModel.id  = apiService.generateUUID();
			collectionService.addModelAtIndex( self.model.indicators, indicatorModel, index );

			self.getIndex = 'gr' + self.groupIndex + 'in' + ( self.model.indicators.length - 1 );
		}

		function activate () {
			logger.info( 'Activated Group Indicator View' );
		}

		self.getIndicators    = getIndicatorsHandler;
		self.addIndicator     = addIndicatorHandler;
		self.trimTemplateName = trimTemplateName;

		activate();
	}

	angular
		.module( 'app.templates' )
		.controller( 'GroupIndicator', GroupIndicator );

	GroupIndicator.$inject = [ '$q', 'coreservice', 'logger', 'collectionService', 'indicatorService', 'apiService', '$scope' ];
} )( );
